<mat-form-field appearance="standard">
    <mat-label>{{ label }}
        <span class="form-field__req" *ngIf="required">*</span>
    </mat-label>
    <input matInput type="date-local" class="" [matDatepicker]="picker" (dateChange)="onChanged($event)" (dateInput)="onChanged($event)" (click)="picker.open()" [disabled]="isDisabled ? true : null" [value]="inputValue" [min]="min" [max]="max" placeholder="{{ placeholder || 'Choose a date' }}"
    />
    <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isDisabled">
    </mat-datepicker-toggle>
    <mat-datepicker #picker (closed)="onClosed()"></mat-datepicker>
</mat-form-field>

<div class="form-field__error" [class.form-field_error]="hasError()">
    <ng-container *ngIf="control && errorKey" [ngSwitch]="errorKey">
        <span *ngSwitchCase="'min'">Minimum {{control?.errors[errorKey].min}}</span>
        <span *ngSwitchCase="'max'">Maximum {{control?.errors[errorKey].max}}</span>
        <span *ngSwitchCase="'required'">This field is <strong>required</strong></span>
        <span *ngSwitchCase="'requiredtrue'">This field is <strong>required</strong></span>
        <span *ngSwitchCase="'minlength'">At least {{control?.errors[errorKey].requiredLength}} character</span>
        <span *ngSwitchCase="'maxlength'">No more than {{control?.errors[errorKey].requiredLength}} character</span>
        <span *ngSwitchCase="'pattern'">
            <span *ngIf="patternError">{{patternError}}</span>
        <span *ngIf="!patternError">Pattern dose not match</span>
        </span>
        <span *ngSwitchCase="'min'"></span>
    </ng-container>
    <ng-container *ngIf="not18">
        <span>Minimum age should be 18.</span>
    </ng-container>
</div>
